<template>
  <text-subpage page-type="faq" />
</template>

<script>
import Vue from 'vue'
import TextSubpage from '~brand-components/discover/shared/text-subpage.vue'

export default Vue.extend({
  components: {
    TextSubpage,
  },
})
</script>
